export const getCookie = (name) => {
    const appName = window.location.hostname
    let updatedKey = name;

    if(appName.includes('demo')){
      updatedKey = `${name}STG`;
    }
    const match = document.cookie.match(new RegExp(`(^| )${updatedKey}=([^;]+)`));
    if (!match) return null;
    let val = decodeURIComponent(match[2]);
    return val.replace(/z$/, 'Z');
  };
   
  // export const setCookie = (name, value, days = 1) => {
  //   const expires = new Date(Date.now() + days * 864e5).toUTCString();
  //   const isLocalhost = window.location.hostname === 'localhost';
   
  //   let cookieStr = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  //   if (!isLocalhost) {
  // cookieStr += '; domain=.eci.gov.in'; 
  //   }
   
  //   document.cookie = cookieStr;
  // };

  export const setCookie = (name, value, days = 1) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    const isLocalhost = window.location.hostname === 'localhost';
    const isHttps = window.location.protocol === 'https:';
    const appName = window.location.hostname
    let updatedKey = name;

    if(appName.includes('demo')){
      updatedKey = `${name}STG`;
    }
   
    let cookieStr = `${updatedKey}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
   
    if (!isLocalhost) {
  cookieStr += '; domain=.eci.gov.in';
    }
   
    if (isHttps) {
      cookieStr += '; Secure; SameSite=Lax';
    }
   
    document.cookie = cookieStr;
  };